import type { ReactNode } from "react";
import { createContext, useContext, useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import type { contextsSeriesWidgetContextProviderArticle$key } from "~/queries/__generated__/contextsSeriesWidgetContextProviderArticle.graphql";

type ContextValue = {
  campaign: string;
  currentItemIndex: number;
};

const SeriesWidgetContext = createContext<ContextValue>({
  campaign: "",
  currentItemIndex: 0,
});

type Props = {
  children: ReactNode;
  currentItemIndex: number;
  reference: contextsSeriesWidgetContextProviderArticle$key;
};

export const SeriesWidgetContextProvider: React.FunctionComponent<Props> = ({
  children,
  currentItemIndex,
  reference,
}) => {
  const article = useFragment(
    graphql`
      fragment contextsSeriesWidgetContextProviderArticle on Article {
        ...seriesWidgetEntrypointHeadlineArticle
        seriesContainer {
          headline
        }
      }
    `,
    reference,
  );

  const campaign = useMemo(
    () => `${(article.seriesContainer?.headline ?? "").replaceAll(/\s+/g, "_")}`,
    [article.seriesContainer?.headline],
  );

  return (
    <SeriesWidgetContext.Provider
      value={{
        campaign,
        currentItemIndex,
      }}
    >
      {children}
    </SeriesWidgetContext.Provider>
  );
};
SeriesWidgetContextProvider.displayName = "SeriesWidgetContextProvider";

export const useSeriesWidgetContext = () => useContext(SeriesWidgetContext);
